import "react-datepicker/dist/react-datepicker.css";

import React from "react";
import DatePicker from "react-datepicker";
import { Calendar } from "lucide-react";
import { fr } from "date-fns/locale";

import {
  FieldLabel,
  OnboardingInput,
  OnboardingSelect,
  PrimaryButton,
} from "./OnboardingFields";

function DetailsStep({
  form,
  onChange,
  onDateChange,
  onBack,
  onContinue,
  isLoading,
}) {
  const ageRestriction = new Date().setFullYear(new Date().getFullYear() - 15);

  const canContinue =
    form.nationality &&
    form.birthPlace.trim() &&
    form.birthNumber.trim() &&
    form.dateOfBirth;

  return (
    <div className="flex flex-col min-h-[calc(100vh-8rem)] sm:min-h-0">
      <h2 className="font-logo text-3xl sm:text-4xl text-black mb-6 sm:mb-8 leading-tight">
        Dis-nous en un peu plus sur toi
      </h2>

      <div className="space-y-5 flex-1">
        <div>
          <FieldLabel htmlFor="nationality" required>
            Nationalité
          </FieldLabel>
          <OnboardingSelect
            id="nationality"
            value={form.nationality}
            onChange={(e) => onChange("nationality", e.target.value)}
            placeholder="Nationalité"
          >
            <option value="Fr">Française</option>
          </OnboardingSelect>
        </div>

        <div>
          <FieldLabel htmlFor="dateOfBirth" required>
            Date de naissance
          </FieldLabel>
          <div className="relative">
            <DatePicker
              id="dateOfBirth"
              selected={form.dateOfBirth}
              onChange={onDateChange}
              locale={fr}
              dateFormat="dd/MM/yyyy"
              maxDate={ageRestriction}
              placeholderText="jj/mm/aaaa"
              showYearDropdown
              scrollableMonthYearDropdown
              yearDropdownItemNumber={100}
              showMonthDropdown
              dropdownMode="select"
              className="w-full rounded-lg border border-greyLight bg-white py-3 pl-4 pr-12 font-josefin text-secondaryText placeholder:text-greyLight outline-none focus:border-primaryText transition duration-200 ease-in-out"
              wrapperClassName="w-full"
            />
            <Calendar
              size={18}
              className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-greyLight"
            />
          </div>
        </div>

        <div>
          <FieldLabel htmlFor="birthPlace" required>
            Lieu de naissance
          </FieldLabel>
          <OnboardingInput
            id="birthPlace"
            placeholder="Lieu de naissance"
            value={form.birthPlace}
            onChange={(e) => onChange("birthPlace", e.target.value)}
            required
          />
        </div>

        <div>
          <FieldLabel htmlFor="birthNumber" required>
            N° de département de naissance
          </FieldLabel>
          <OnboardingInput
            id="birthNumber"
            placeholder="N° de département de naissance"
            value={form.birthNumber}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                onChange("birthNumber", value);
              }
            }}
            inputMode="numeric"
            maxLength={3}
            required
          />
          <p className="mt-1.5 text-right font-josefin text-xs sm:text-sm text-grey">
            Saisis &quot;99&quot; si tu es né(e) à l&apos;étranger
          </p>
        </div>
      </div>

      <div className="mt-8 sm:mt-10 flex flex-col-reverse sm:flex-row sm:justify-between gap-3 pb-4">
        <PrimaryButton
          variant="outline"
          onClick={onBack}
          disabled={isLoading}
          className="w-full sm:w-auto"
        >
          Retour
        </PrimaryButton>
        <PrimaryButton
          variant="green"
          onClick={onContinue}
          disabled={!canContinue || isLoading}
          className="w-full sm:w-auto"
        >
          {isLoading ? "Enregistrement…" : "Continuer"}
        </PrimaryButton>
      </div>
    </div>
  );
}

export default DetailsStep;
